import { render, staticRenderFns } from "./OneTimePassRegisterModalSection.vue?vue&type=template&id=cb1ad964&scoped=true"
import script from "./OneTimePassRegisterModalSection.vue?vue&type=script&lang=ts"
export * from "./OneTimePassRegisterModalSection.vue?vue&type=script&lang=ts"
import style0 from "./OneTimePassRegisterModalSection.vue?vue&type=style&index=0&id=cb1ad964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1ad964",
  null
  
)

export default component.exports